import { axios } from '@/utils/request'

const api = {
  getMenuTreeByServiceAndRole: '/sso/role/getMenuTreeByServiceAndRole', // 系统菜单
  getServiceCurrentDomainDetail: '/sso/role/getServiceCurrentDomainDetail',
  selectSystemMenuPlatformCode: '/sso/role/selectSystemMenuPlatformCode',
  updatePlatformCode: '/sso/role/updatePlatformCode', // 切换轻易ERP
  queryECMenuTreeByPlatformCode: '/sso/role/queryECMenuTreeByPlatformCode', // 动态菜单权限
  updateSystemUpdateFlag: '/sso/role/updateSystemUpdateFlag' // 切换展示升级付费页面按钮
}

export default api
export const getMenuTreeByServiceAndRole = params => axios.post(api.getMenuTreeByServiceAndRole, params)
export const getServiceCurrentDomainDetail = params => axios.post(api.getServiceCurrentDomainDetail, params)
export const selectSystemMenuPlatformCode = params => axios.post(api.selectSystemMenuPlatformCode, params)
export const updatePlatformCode = params => axios.post(api.updatePlatformCode, params)
export const queryECMenuTreeByPlatformCode = params => axios.post(api.queryECMenuTreeByPlatformCode, { ...params, sourceSystem: 'SSO_SYS_USER_SAIL' })
export const updateSystemUpdateFlag = params => axios.post(api.updateSystemUpdateFlag, params)
